import React from 'react';

import { Routes, Route } from 'react-router-dom';

import AuthenticatedApp from './AuthenticatedApp';
import Login from './auth';
import { PrivateRoute } from './common/components';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/*" element={<Login />} />
      <Route
        path="app/*"
        element={
          <PrivateRoute>
            <AuthenticatedApp />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default App;
